export default {
    data: {
        columns: [
            {
                headerName: 'Date',
                type: 'date',
                field: 'date',
            },
            {
                headerName: 'User',
                type: 'string',
                field: 'user',
            },
            {
                headerName: 'Value',
                type: 'string',
                field: 'value',
            },
            {
                headerName: 'Source',
                type: 'string',
                field: 'source',
            },
        ],
        rows: [
            {
                id: 1,
                gpId: 1,
                user: 'User 1',
                value: 'The GP 1',
                date: '2019-02-26T20:00:44.000Z',
                source: 'High',
            },
            {
                id: 2,
                gpId: 2,
                user: 'User 2',
                value: 'The GP 2',
                date: '2019-02-27T20:00:44.000Z',
                source: 'Lower',
            },
            {
                id: 3,
                gpId: 3,
                user: 'User 3',
                value: 'The GP 3',
                date: '2019-02-28T20:00:44.000Z',
                source: 'High',
            },
            {
                id: 4,
                gpId: 4,
                user: 'User 3',
                value: 'The GP 3',
                date: '2019-02-28T20:00:44.000Z',
                source: 'Lower',
            },
        ],
    },
    meta: {
        page: 10,
    },
}
